<app-partner-registration-form #partnerRegistrationForm (eventRegister)="onRegister()" (eventBack)="onBack()"></app-partner-registration-form>
